import { render, staticRenderFns } from "./Signup-Teacher-3Step-New.vue?vue&type=template&id=263e0f1b&scoped=true"
import script from "./Signup-Teacher-3Step-New.vue?vue&type=script&lang=js"
export * from "./Signup-Teacher-3Step-New.vue?vue&type=script&lang=js"
import style0 from "./Signup-Teacher-3Step-New.vue?vue&type=style&index=0&id=263e0f1b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263e0f1b",
  null
  
)

export default component.exports